/**
 * Formato para pintar. **Nunca para calcular.**
 *
 * El dinero viaja y se opera en micros enteros, igual que en el backend: un float
 * acumula error de redondeo y en facturación esas sumas son millones de filas.
 * Aquí solo se convierte a texto, en el último momento y para un humano.
 */

const MICROS_POR_UNIDAD = 1_000_000

export function formatearCoste(micros: number, moneda = "USD"): string {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: moneda,
    minimumFractionDigits: 2,
    // Importes muy pequeños son lo normal aquí: 0.000425 no debe verse como 0,00.
    maximumFractionDigits: micros < 10_000 ? 6 : 2,
  }).format(micros / MICROS_POR_UNIDAD)
}

export function formatearNumero(n: number): string {
  return new Intl.NumberFormat("es-ES").format(n)
}

export function formatearPorcentaje(p: number): string {
  return `${new Intl.NumberFormat("es-ES", { maximumFractionDigits: 1 }).format(p)} %`
}

export function formatearFecha(iso: string | null | undefined): string {
  if (!iso) return "—"
  return new Intl.DateTimeFormat("es-ES", { dateStyle: "medium", timeStyle: "short" }).format(
    new Date(iso),
  )
}

/** Duraciones en ms: `270 ms`, `1,2 s`. */
export function formatearMs(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return "—"
  if (ms < 1000) return `${formatearNumero(ms)} ms`
  // `toFixed` ignora el idioma y produce "1.2 s" con punto, junto a "60,5 %" con
  // coma. La incoherencia se ve en la misma tabla.
  const segundos = new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(ms / 1000)
  return `${segundos} s`
}
